export type Currency = {
  name: string;
  code: string;
  specialCharacter?: string;
}
export const currencies: Currency[] = require('./currencies.json');
export function getCurrencyByCode(code: string) {
  return currencies.find(c => c.code == code) ?? null
}
